// extracted by mini-css-extract-plugin
module.exports = {"commentConfigArea":"CommentConfig_commentConfigArea__2EEq-","button":"CommentConfig_button__YQdMd","border":"CommentConfig_border__1LABh"};